import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";

interface LoadingProps {
    isVisible: boolean;
}

const Loading = ({ isVisible }: LoadingProps) => (
    <Backdrop
        sx={{ color: "#fff", zIndex: theme => theme.zIndex.drawer + 1 }}
        open={isVisible}
    >
        <CircularProgress color="inherit" />
    </Backdrop>
);

export default Loading;
